'use strict';

angular.module('shiftTraderApp')
  .controller('SmartSchedulingCtrl', function ($scope, $timeout, $interval, WorkPeriods, Session, WorkPeriodStore,
                                               InternalAnalyticsService, ShepherdTourService, UsersPositions, $log,
                                               TimeService, $rootScope, $filter, NotesOverlayContextService,
                                               SmartSchedulingCoordinator, WeightCalculationService, $controller,
                                               SAErrorHandler, GlobalRxFeed) {

    var params = $scope.params;
    var $uibModalInstance = $scope.uibModalInstance;

    $uibModalInstance.rendered.then(function () {
      GlobalRxFeed.push('modal-opened', 'smart-scheduling', $uibModalInstance)
    })

    var baseCtrl = $controller('BaseSmartCWPNewCtrl', {$scope: $scope, params: params});

    NotesOverlayContextService.setDateContext($scope.currentDate, ['scheduling']);

    var shiftsByPositionIndex;

    var coordinatorName = 'smart-scheduling';
    var coordinator = SmartSchedulingCoordinator.getCoordinatorByName(coordinatorName);
    coordinator.setCurrentDate($scope.currentDate);
    coordinator.setOvertimeHoursThreshold($scope.org.organization_config.overtime_threshold_hours);
    coordinator.setPenalizeTargetGtOvertime($scope.org.organization_config.penalize_target_gt_overtime);


    this.getCoordinatorName = function() {
      return coordinatorName;
    };

    coordinator.channel.filterByType(['analysisStart', 'analysisCompleted']).subscribe(function(update) {

      if (update.type === 'analysisCompleted') {
        // This is not necessarily the best way to do this...
        $timeout(function() {
          $('.smart_scheduling_modal').removeClass('smart-scheduling-calculating');
        }, 100);

      } else if (update.type === 'analysisStart' && _.isNull(update.data)) {
        $('.smart_scheduling_modal').addClass('smart-scheduling-calculating');
      }
    });

    var allShifts = params.allShifts;
    $scope.relevantWorkPeriods = angular.copy(params.workPeriods);

    $scope.createdAssignedWorkPeriods = [];
    $scope.createdUnassignedWorkPeriods = [];
    $scope.deletedShifts = [];
    $scope.assignedWorkPeriods = [];

    $scope.creationStats = {
      createdAssignedWorkPeriods: 0,
      createdUnassignedWorkPeriods: 0,
      deletedShifts: 0,
      assignedWorkPeriods: 0
    };

    if ($scope.relevantWorkPeriods.length > 0) {
      // SATODO: I think this can be modified to form SWPObject's w/ the original shift and the current WP --
      //   giving ability to still look at entire template in smart scheduling

      var shiftsToShow = lodash.filter(allShifts, function(s) {
        return lodash.every($scope.relevantWorkPeriods, function(wp) {
          // if position of WP has changed, show it to smart scheduling
          return wp.shift_id !== s.id || wp.position_id !== s.position_id;
        });
      });

      var workPeriodsToFill = lodash.filter($scope.relevantWorkPeriods, function(wp) {
        return !wp.$isAssigned();
      });

    } else {
      workPeriodsToFill = [];
      shiftsToShow = allShifts;
    }

    if (shiftsToShow.length === 0 && workPeriodsToFill.length === 0) {
      $uibModalInstance.dismiss();
      ShepherdTourService.triggerEvent('smartSchedulingClosed', 1000);
    }


    function SWPObject(obj) {
      var that = this;
      this._objType = 'SWPObject';

      this._startTimeUnix = obj._startTimeUnix;
      this.position_id = obj.position_id;
      this.position = obj.position;
      this._dismissed = !!obj._dismissed;

      if (obj.$isShift()) {
        this.shift = obj;
      } else if (obj.$isWorkPeriod() && !obj.$isAssigned()) {
        this.wp = obj;
      } else if (obj.$isWorkPeriod() && obj.$isAssigned()) {
        this.wp = obj;
      }

      this.hasBeenFilled = function() {
        return that.wp && that.wp.$isAssigned();
      };

      this.hasWorkPeriod = function() {
        return !!that.wp;
      };

      this.hasBeenDismissed = function() {
        return that._dismissed;
      };

      this.setDismissed = function() {
        that._dismissed = true;
      };

      this.start_time_fmt = function(fmt) {
        return that.wp && that.wp.start_time.format(fmt || 'h:mma') || that.shift && that.shift.start_time.format(fmt || 'h:mma');
      };

      this.end_time_fmt = function(fmt) {
        return that.wp && that.wp.end_time.format(fmt || 'h:mma') || that.shift && that.shift.end_time.format(fmt || 'h:mma');
      };

      this.range_twix = function() {
        return that.wp && that.wp.range_twix || that.shift && that.shift.range_twix;
      };

      this.setWorkPeriod = function(wp) {
        that._dismissed = false;
        that.wp = wp;
        // may need to reset that._dismissed here?
      };

      this.unsetWorkPeriod = function() {
        that.wp = null;
      };
    }

    $scope.itemsToFill = lodash([shiftsToShow, workPeriodsToFill])
      .flatten()
      .map(function(swp) {
        return new SWPObject(swp);
      })
      .sortBy('_startTimeUnix')
      .value();

    $scope.allPositionsWithShifts = lodash.filter($scope.allPositions, function(pos) {
      return lodash.some($scope.itemsToFill, function(swp) {
        return pos.id === swp.position_id;
      });
    });

    var tempPositionsWithShifts = [];
    lodash.forEach($scope.allDepartments, function(dept) {
      lodash.forEach(dept.positions, function(pos) {
        if (lodash.some($scope.itemsToFill, function(swp) {
            return pos.id === swp.position_id;
          })) {
          tempPositionsWithShifts.push(pos);
        }
      });
    });

    $scope.allPositionsWithShifts = tempPositionsWithShifts;


    var getWeightingInfo = function(emp) {
      var res = coordinator.getAnalysisForEmpId(emp.id);

      if (res) {
        return {
          targetHours: res.analysis.targetHours,
          availability: res.analysis.availabilityIntersection.weight,
          overlap: res.analysis.overlap.weight,
          overtime: res.analysis.overtime.weight,
          blackout: res.analysis.blackout,
          availIndex: res.analysis.availabilityIndex,
          listRankIndex: res.analysis.listRankingIndex,
          lastWeek: res.analysis.lastWeekWorkPeriod.weight,
          multiShift: res.analysis.multiShift.weight
        };
      } else {
        return null;
      }
    };


    $scope.$on('saMiniDayView:objectSelected', function(event, data) {
      $log.log('saMiniDayView:objectSelected', data);
      event.stopPropagation();
      window.logTime('saMiniDayView:objectSelected $ON: ' + data);
      $scope.goToShift(data.type, data.id);
    });

    var calcNextShiftIndices = function(canWrap, refPosIdx, refShiftIdx) {
      // returns undefined if there is not a next
      // otherwise, returns nextPositionIndex and nextShiftIndex

      var thePosIdx = lodash.isUndefined(refPosIdx) ? $scope.currentPositionIndex : refPosIdx;
      var theShiftIdx = lodash.isUndefined(refShiftIdx) ? $scope.currentShiftPositionIndex : refShiftIdx;

      // in the odd case that either index variable is undefined, return undefined rather than get array indice errors
      if (lodash.isUndefined(thePosIdx) || lodash.isUndefined(theShiftIdx)) {
        return undefined;
      }

      var atEndOfCurrentPosition = (shiftsByPositionIndex[thePosIdx].length - 1) === theShiftIdx;
      var atLastPosition = thePosIdx === (shiftsByPositionIndex.length - 1);

      if (atEndOfCurrentPosition && atLastPosition) {
        return canWrap ? {
          posIdx: 0,
          shiftIdx: 0
        } : undefined;
      } else if (atEndOfCurrentPosition && !atLastPosition) {
        return {
          posIdx: thePosIdx + 1,
          shiftIdx: 0
        };
      } else if (!atEndOfCurrentPosition) {
        return {
          posIdx: thePosIdx,
          shiftIdx: theShiftIdx + 1
        }
      }
    };

    var calcNextUnassignedShiftIndices = function() {
      var calcNextIndices;
      var obj;
      var fetchIndicesAgain = true;
      var startingPosIdx = $scope.currentPositionIndex;
      var startingShiftIdx = $scope.currentShiftPositionIndex;
      var prevNextIndices = {};
      var res;

      // should call calcNextShiftIndices until a shift that:
      //     - is a _type="shift" and does not have a _workPeriod property
      //     - is a _type="shift" and has a _workPeriod property and !$isAssigned()
      //     - is a _type="workPeriod" and !$isAssigned()

      while (fetchIndicesAgain) {
        calcNextIndices = calcNextShiftIndices(true, prevNextIndices.posIdx, prevNextIndices.shiftIdx);
        if (!lodash.isUndefined(calcNextIndices)) {
          if (calcNextIndices.posIdx === startingPosIdx && calcNextIndices.shiftIdx === startingShiftIdx) {
            fetchIndicesAgain = false;
            res = undefined;
          } else {
            obj =  shiftsByPositionIndex[calcNextIndices.posIdx][calcNextIndices.shiftIdx];

            if (!obj.hasBeenFilled() && !obj.hasBeenDismissed()) {
              fetchIndicesAgain = false;
              res = calcNextIndices;
            }
          }
        } else {
          fetchIndicesAgain = false;
          res =  undefined;
        }
        prevNextIndices = lodash.cloneDeep(calcNextIndices);
      }
      return res;
    };

    function sendRenderMessageToMiniDayView() {
      $scope.$broadcast('sa:saMaqMiniDayView:scheduleRender');
    }


    function setCurrentShiftToObject(swp) {
      // for a given SWPObject, find the matching one in the itemsToFill array
      var matchingIndex = lodash.findIndex($scope.itemsToFill, function(item) {
        return (item.shift && swp.shift && item.shift.id === swp.shift.id) ||
          ((!item.shift || !swp.shift) && item.wp && swp.wp && item.wp.id === swp.wp.id);
      });

      if (matchingIndex > -1) {
        $scope.currentShift = $scope.itemsToFill[matchingIndex];
      }
    }

    var updateNumUnassigned = function() {
      var oldVal = lodash.clone($scope.numUnassignedItemsNotDismissed);
      $scope.numUnassignedItemsNotDismissed = lodash.filter($scope.itemsToFill, function(obj) {
        return !obj.hasBeenFilled();
      }).length;
      if (!lodash.isUndefined(oldVal) && oldVal !== $scope.numUnassignedItemsNotDismissed) {
        $scope.theToggler = !!!$scope.theToggler;
      }
    };

    function setNewFocusedSWP(swp) {
      // wrap this in a timeout so that it will digest immediately
      $timeout(function() {
        setCurrentShiftToObject(swp);
        sendRenderMessageToMiniDayView();
        baseCtrl.calcAndSetUserLists(swp.position_id);
        coordinator.setUsers($scope.userListWithPosition);
        coordinator.calculateForShift($scope.currentShift);
      }, 0);
    }

    $scope.goToShift = function(_type, id, skipScrollSet) {
      window.logTime('goToShift: ', _type, id);
      var matchingObj = lodash.find($scope.itemsToFill, function(item) {
        return (_type === 'shift' && item.shift && item.shift.id === id) ||
          (_type === 'workPeriod' && item.wp && item.wp.id === id);
      });

      window.logTime('goToShift: foundMatchingObj');
      console.log(matchingObj);

      $scope.currentPositionIndex = lodash.findIndex($scope.allPositionsWithShifts, function(pos) {
        return pos.id === matchingObj.position_id;
      });

      $scope.currentShiftPositionIndex = lodash.findIndex(shiftsByPositionIndex[$scope.currentPositionIndex], function(wps) {
        return (_type === 'shift' && wps.shift && wps.shift.id === id) ||
          (_type === 'workPeriod' && wps.wp && wps.wp.id === id);
      });
      window.logTime('goToShift: calculatedCurrentShiftPositionIndices');

      if (!skipScrollSet) {
        baseCtrl.animateEmployeeBoxToScrollPosition(0);
      }

      window.logTime('goToShift: calcAndSetUserLists');
      setNewFocusedSWP(matchingObj);
    };

    $scope.goToNextShift = function() {
      $log.log('goToNextShift');
      baseCtrl.animateEmployeeBoxToScrollPosition(0);

      // get the indices for the next shift
      var i = calcNextUnassignedShiftIndices();
      if (lodash.isUndefined(i)) {
        $scope.userListWithPosition = [];
        $scope.userListWithoutPosition = [];
        $scope.currentShift = undefined;
        $scope.$broadcast('sa:employeeSelectedForInfo', undefined);
      } else {
        $scope.currentPositionIndex = i.posIdx;
        $scope.currentShiftPositionIndex = i.shiftIdx;

        setNewFocusedSWP(shiftsByPositionIndex[i.posIdx][i.shiftIdx]);

        // setCurrentShiftToObject(shiftsByPositionIndex[i.posIdx][i.shiftIdx]);
           // $scope.currentShift = shiftsByPositionIndex[i.posIdx][i.shiftIdx];
        // baseCtrl.calcAndSetUserLists($scope.allPositionsWithShifts[$scope.currentPositionIndex].id);
      }

      // if ($scope.currentShift) {
      //   notifyListItemsForChangedFocusedShifts(true, false);
      // }
    };

    var addUserToShift = function(user) {
      // $log.log('TIME: ', (moment.utc().valueOf() - window.baseTime), 'addUserToShift called');

      var exec = function() {
        if ($scope.currentShift.hasWorkPeriod()) {
          updateWorkPeriod(user);
        } else {
          $log.log('changeWorkPeriodAssignment');
          createWorkPeriod(user);
        }
      };

      if (lodash.some(user.users_positions, function(up) {
          return lodash.isNull(up.id);
        })) {
        var up = lodash.find(user.users_positions, {position_id: $scope.currentShift.position_id, id: null});
        var upClone = lodash.cloneDeep(up);

        delete upClone.id;
        UsersPositions.create(upClone)
          .then(function(newUp) {
            if (lodash.has($scope.state.writeIn.usersPositionAdditions, user.id)) {
              var idx = lodash.indexOf($scope.state.writeIn.usersPositionAdditions[user.id], upClone.position_id);
              if (idx > -1) {
                $scope.state.writeIn.usersPositionAdditions[user.id].splice(idx, 1);
              }
            }

            up.id = newUp.id;
            up.position = lodash.find($scope.allPositions, {id: newUp.position_id});
            exec();
            $scope.state.writeIn.showInput = false;
          }, function(response) {
            SAErrorHandler.processError(response);
          });
      } else {
        exec();
      }
    };

    $scope.$on('addUserToShift', function(event, user) {
      console.log('addUserToShift seen');
      event.stopPropagation();
      if (!lodash.isUndefined($scope.currentShift)) {
        addUserToShift(user);
      } else {
        $log.log('currentShift was undefined');
      }
    });

    $scope.$on('unassignUserFromShift', function(event) {
      event.stopPropagation();
      $scope.unassignEmployeeFromWorkPeriod();
    });

    $scope.createUnassignedWorkPeriod = function() {
      if (!$scope.currentShift.hasWorkPeriod()) {
        createWorkPeriod(); // call w/o argument so that it doesn't get assigned to a user
      } else {
        $scope.goToNextShift();
      }
    };

    $scope.unassignEmployeeFromWorkPeriod = function() {
      updateWorkPeriod({ id: null })
    }

    var updateActionCounters = function(newWp, newProperty, oldWp) {
      var idx, actionOccurred;

      lodash.forEach(['assignedWorkPeriods', 'deletedShifts', 'createdAssignedWorkPeriods', 'createdUnassignedWorkPeriods'], function(property) {
        if (oldWp) {
          idx = lodash.findIndex($scope[property], {id: oldWp.id});
          if (idx > -1) {
            if (newProperty === property) {
              $scope[property][idx] = newWp;
            } else {
              $scope[property].splice(idx, 1);
              $scope[newProperty].push(newWp);
              $scope.creationStats[property] -= 1;
              $scope.creationStats[newProperty] += 1;
            }
            actionOccurred = true;
          }
        } else {
          if (newProperty === property) {
            $scope[newProperty].push(newWp);
            $scope.creationStats[newProperty] += 1;
          }
        }
      });

      updateNumUnassigned();

      return !!actionOccurred;
    };

    var changeWorkPeriodCreationState = function(state) {
      $scope.state.workPeriodCreationStatus = !!state;

      if ($scope.state.workPeriodCreationStatus) {
        $('.smart_scheduling_modal').addClass('creating_shift');
      } else {
        $timeout(function() {
          $('.smart_scheduling_modal').removeClass('creating_shift');
        }, 100);
      }
    };


    $scope.dismissShift = function() {

      updateActionCounters($scope.currentShift, 'deletedShifts');

      if ($scope.currentShift.hasBeenFilled()) {
        $scope.currentShift.wp.$update({active: false})
            .then(function(data) {
              $scope.currentShift.setDismissed();
              $scope.currentShift.unsetWorkPeriod();
              WorkPeriodStore.replaceById(data);
              // var posIdx = lodash.findIndex($scope.allPositionsWithShifts, {id: data.position_id});
              // var idx = lodash.findIndex(shiftsByPositionIndex[posIdx], {id: data.id});
              // shiftsByPositionIndex[posIdx][idx] = data;
              $scope.goToNextShift();
            }, function(response) {
            SAErrorHandler.processError(response);
          });
      } else {
        $scope.currentShift.setDismissed();
        $scope.goToNextShift();
      }

    };

    $scope.userIsDone = function() {
      // kill the coordinator instance so it reloads when it opens back up
      SmartSchedulingCoordinator.killCoordinator(coordinator);

      // reset all of the _workPeriod entries on shifts so that shifts
      //   don't look filled out when you try to apply a template to the next day
      lodash.forEach($scope.itemsToFill, function(swp) {
        delete swp._dismissed;
        delete swp._workPeriod;
      });

      baseCtrl.clearOutUninitializedUsersPositions();

      $uibModalInstance.close({
        assignedShifts: $scope.createdAssignedWorkPeriods,
        unassignedShifts: $scope.createdUnassignedWorkPeriods,
        deletedShifts: $scope.deletedShifts,
        assignedWorkPeriods: $scope.assignedWorkPeriods
      });
      ShepherdTourService.triggerEvent('smartSchedulingClosed', 1000);
    };


    function updateWorkPeriod(assignedEmployee) {
      changeWorkPeriodCreationState(true);

      $scope.currentShift.wp.$update({user_id: assignedEmployee.id})
        .then(function(wp) {
          console.log('updated wp', wp);
          var oldWorkPeriod = lodash.cloneDeep($scope.currentShift.wp);
          oldWorkPeriod.active = false;
          $scope.currentShift.setWorkPeriod(wp);
          updateActionCounters(wp, 'assignedWorkPeriods', oldWorkPeriod);

          WorkPeriodStore.replaceById(wp);
          coordinator.forceWeekOfWorkPeriodUpdate(false);
          $scope.goToNextShift();
          changeWorkPeriodCreationState(false);

          // send off some data to the analytics backend
          var weights = getWeightingInfo(assignedEmployee);

          if (weights) {
            InternalAnalyticsService.captureAnalytic('smart_scheduling:update_work_period', {
              _v: 1,
              _d: {
                shift_id: wp.shift_id,
                position_id: wp.position_id,
                user_id: wp.user_id ? wp.user_id : null,
                work_period_id: wp.id,
                user_rec_idx: lodash.findIndex(baseCtrl.getSortedCurrentUsersList(), {id: assignedEmployee.id}),
                weighting: weights
              }
            });

          }
        }, function(response) {
          SAErrorHandler.processError(response);
          changeWorkPeriodCreationState(false);
        });
    }





    function createWorkPeriod(assignedEmployee) {
      //$log.log('TIME: ', (moment.utc().valueOf() - window.baseTime), 'submitWorkPeriod top');
      window.logTime('submitWorkPeriod: top');

      var shiftOrWp = $scope.currentShift.shift;

      var data = {};
      data.start_time = moment(shiftOrWp.start_time).utc().format();
      data.end_time = moment(shiftOrWp.end_time).utc().format();
      data.organization_id = $scope.org.id;
      data.position_id = shiftOrWp.position_id;
      data.shift_id = shiftOrWp.id;

      if (assignedEmployee) {
        data.user_id = assignedEmployee.id;
      }

      if ($scope.currentShift._timeDeltaFromShift) {
        data.time_delta_from_shift = true;
      }

      changeWorkPeriodCreationState(true);

      window.logTime('submitWorkPeriod: just before WorkPeriods.create');
      WorkPeriods.create(data)
        .then(function(wp) {
          window.logTime('submitWorkPeriod: just inside WorkPeriods.create callback');
          // console.log('the new wp', wp);
          $scope.currentShift.setWorkPeriod(wp);
          // console.log($scope.currentShift);
          // console.log($scope.itemsToFill);
          if (assignedEmployee) {
            updateActionCounters(wp, 'createdAssignedWorkPeriods');
          } else {
            updateActionCounters(wp, 'createdUnassignedWorkPeriods');
          }

          window.logTime('submitWorkPeriod: just before WorkPeriodStore.addWorkPeriod');
          WorkPeriodStore.addWorkPeriod(wp)
            .then(function() {
              window.logTime('submitWorkPeriod: just inside WorkPeriodStore.addWorkPeriod');
              coordinator.forceWeekOfWorkPeriodUpdate(false);
              $scope.goToNextShift();
              changeWorkPeriodCreationState(false);
              sendRenderMessageToMiniDayView();
            });

          var weights = assignedEmployee ? getWeightingInfo(assignedEmployee) : null;

          if (weights || !assignedEmployee) {
            // send off some data to the analytics backend
            InternalAnalyticsService.captureAnalytic('smart_scheduling:create_work_period', {
              _v: 1,
              _d: {
                shift_id: data.shift_id,
                position_id: data.position_id,
                user_id: data.user_id ? data.user_id : null,
                work_period_id: wp.id,
                user_rec_idx: assignedEmployee ? lodash.findIndex(baseCtrl.getSortedCurrentUsersList(), {id: assignedEmployee.id}) : null,
                weighting: assignedEmployee ? weights : null
              }
            });
          }
        },
      function(response) {
        SAErrorHandler.processError(response);
        changeWorkPeriodCreationState(false);
      });
    }


    $scope.statusInWords = function(obj) {
      if (obj.hasBeenDismissed()) {
        return 'Dismissed';
      } else if (!obj.hasBeenFilled()) {
        return 'Unassigned'
      } else {
        return 'Assigned';
      }
    };

    ShepherdTourService.triggerEvent('smartSchedulingOpened', 1500);

    //uses allPositionsWithShifts index!
    shiftsByPositionIndex = [];
    angular.forEach($scope.allPositionsWithShifts, function() {
      shiftsByPositionIndex.push([]);
    });

    angular.forEach($scope.itemsToFill, function(swp) {
      shiftsByPositionIndex[lodash.findIndex($scope.allPositionsWithShifts, {id: swp.position_id})].push(swp);
    });


    // Initialize currentShift and the positionIndex
    $scope.currentPositionIndex = 0;
    $scope.currentShiftPositionIndex = 0;
    if (shiftsByPositionIndex[$scope.currentPositionIndex][$scope.currentShiftPositionIndex].hasBeenDismissed()) {
      $scope.goToNextShift();
    } else {
      setNewFocusedSWP(shiftsByPositionIndex[$scope.currentPositionIndex][$scope.currentShiftPositionIndex]);
    }

    updateNumUnassigned();
  });
